import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { closest } from 'next/javascripts/modules/dom';
import $ from 'jquery';
import 'next/stylesheets/components/form-fields/member-batch-select-field.scss';

Component('tr-member-batch-select-field', {
  mixins: [eventListenerMixin],

  properties: {
    searching: {
      type: Boolean,
      default: false,
    },
    selectedIds: {
      type: String,
      default: '',
    },
    disabledIds: {
      type: String,
      default: '',
    },
    groupSelectable: {
      type: Boolean,
      default: false,
    },
  },

  init() {
    this.activeList = 'member';
    this.membersListSearchValue = '';
    this.groupsListSearchValue = '';
    this.currentSelectedIds = [];
    this.currentDisabledIds = [];
    if (this.selectedIds) this.currentSelectedIds = this.selectedIds.split(',');
    if (this.disabledIds) this.currentDisabledIds = this.disabledIds.split(',');
  },

  ready() {
    this.initDomElementInstances();
    this.updateResultsCount();
    this.addEventListeners();
  },

  initDomElementInstances() {
    this.searchWrapper = this.querySelector('.search-input');
    this.searchInput = this.searchWrapper.querySelector('input');
    this.clearSearchIcon = this.searchWrapper.querySelector('.twr-resource-del');
    this.tabs = this.querySelector('tr-tabs');
    this.membersList = this.querySelector('.members-list');
    this.groupsList = this.querySelector('.groups-list');
    this.resultsCount = this.querySelector('.select-results .count');
    this.resultsList = this.querySelector('.results-list');
    this.resultItemTemplate = this.querySelector('#result-item-template');
  },

  addEventListeners() {
    this.listenTo(this.searchInput, 'input', this.handleSearch.bind(this));
    this.listenTo(this.clearSearchIcon, 'click', this.clearSearch.bind(this));
    if (this.tabs) this.listenTo(this.tabs, 'tr-tabs:activated', this.handleTabActivate.bind(this));
    this.listenTo(this, 'tr-scroll-load-trigger:loading', this.loadMore.bind(this));
    this.listenTo(this.membersList, 'click', this.handleMemberItemClick.bind(this));
    if (this.groupsList) {
      this.listenTo(this.groupsList, 'click', this.handleGroupItemClick.bind(this));
    }
    this.listenTo(this.resultsList, 'click', this.handleResultItemClick.bind(this));
  },

  handleSearch() {
    this.updateSearch();
    this.syncActiveListSearchValue();
  },

  updateSearch() {
    this.searching = !!this.searchInput.value;
  },

  syncActiveListSearchValue() {
    if (this.activeListSearchValueNeedUpdate()) return;

    if (this.activeList === 'member') {
      this.membersListSearchValue = this.searchInput.value;
    } else {
      this.groupsListSearchValue = this.searchInput.value;
    }

    this.searchList();
  },

  async searchList() {
    const list = this.getActivatedList();
    const result = await this.fetchListContent(list.dataset.remoteUrl);

    if (result.html.trim()) {
      list.innerHTML = '';
      list.appendChild(this.transformListItems(result.html));
    } else {
      list.innerHTML = '<div class="empty">没有搜索结果</div>';
    }
  },

  clearSearch() {
    if (!this.searchInput) return;
    this.clearSearchValue();
    this.syncActiveListSearchValue();
  },

  clearSearchValue() {
    this.searchInput.value = '';
    this.updateSearch();
  },

  handleTabActivate(event) {
    this.updateActiveLIst(event.detail.tab.dataset.name);
    this.syncActiveListSearchValue();
  },

  updateActiveLIst(listName) {
    this.activeList = listName;
    this.renderActiveList();
  },

  renderActiveList() {
    if (!this.activeListSearchValueNeedUpdate()) this.getActivatedList().innerHTML = '';
    const activeMember = this.activeList === 'member';
    this.membersList.classList.toggle('active', activeMember);
    this.groupsList.classList.toggle('active', !activeMember);
  },

  activeListSearchValueNeedUpdate() {
    return (this.activeList === 'member' && this.membersListSearchValue === this.searchInput.value)
      || (this.activeList === 'group' && this.groupsListSearchValue === this.searchInput.value);
  },

  getActivatedList() {
    let list;

    if (this.activeList === 'member') {
      list = this.membersList;
    } else {
      list = this.groupsList;
    }

    return list;
  },

  async loadMore(event) {
    const scrollLoadTrigger = event.target;
    const list = closest(scrollLoadTrigger, '.list');
    const lastId = list.querySelector('.list-item:last-of-type').dataset.id;
    const result = await this.fetchListContent(list.dataset.remoteUrl, lastId);

    if (result.html && result.html.trim()) {
      list.insertBefore(this.transformListItems(result.html), scrollLoadTrigger);
    }

    if (result.is_last_page) {
      scrollLoadTrigger.remove();
    } else {
      scrollLoadTrigger.loading = false;
    }
  },

  handleMemberItemClick(event) {
    const item = closest(event.target, '.list-item');
    if (!item || item.classList.contains('disabled')) return;

    if (item.classList.contains('selected')) {
      this.unselectMembers([item.dataset]);
      this.removeSelectedFromGroups(item.dataset.groups.split(','));
    } else {
      this.selectMembers([item.dataset]);
      this.updateGroups(item.dataset.groups.split(','));
    }

    if (this.membersListSearchValue) {
      this.clearSearch();
      this.searchInput.focus();
    }
  },

  handleGroupItemClick(event) {
    const item = closest(event.target, '.list-item');
    if (!item || item.classList.contains('disabled')) return;

    if (item.classList.contains('selected')) {
      if (this.groupSelectable) {
        this.unselectGroup(item.dataset.id);
      } else {
        const membersData = item.dataset.members.split(',').map(id => Object.assign({ id }));
        this.unselectMembers(membersData);
      }

      if (this.groupsListSearchValue) {
        this.clearSearch();
      } else if (!this.groupSelectable) {
        this.updateGroups();
      }
    } else if (this.groupSelectable) {
      this.selectGroup(item.dataset.id);
    } else {
      this.selectGroupMembers(item.dataset.id);
    }
  },

  selectGroup(groupId) {
    this.addItemToSelected(groupId);

    const item = this
      .groupsList.querySelector(`.group-item[data-id="${groupId}"]`);
    item.classList.add('selected');

    const resultItem = this.resultsList
      .querySelector(`.result-item[data-id="${groupId}"]`);
    if (!resultItem) {
      this.resultsList.insertBefore(
        this.renderResultItem(item.dataset),
        this.resultsList.querySelector('.result-item:first-of-type'),
      );
    }

    this.updateResultsCount();

    if (this.groupsListSearchValue) {
      this.clearSearch();
      this.searchInput.focus();
    }
  },

  unselectGroup(groupId) {
    this.removeIdFromSelected(groupId);

    const item = this
      .groupsList.querySelector(`.group-item[data-id="${groupId}"]`);
    if (item) item.classList.remove('selected');

    const resultItem = this.resultsList
      .querySelector(`.result-item[data-id="${groupId}"]`);
    if (resultItem) this.resultsList.removeChild(resultItem);

    this.updateResultsCount();
  },

  async selectGroupMembers(groupId) {
    const item = this
      .groupsList.querySelector(`.list-item[data-id="${groupId}"]`);
    if (item.classList.contains('selecting')) return;

    item.classList.add('selecting');

    const remoteUrl = this.groupsList.dataset.remoteMemberUrl;
    const result = await this.fetchGroupMembers(remoteUrl, groupId);
    this.selectMembers(result);

    if (this.groupsListSearchValue) {
      this.clearSearch();
      this.searchInput.focus();
    } else {
      item.classList.remove('selecting');
      this.updateGroups();
    }
  },

  handleResultItemClick(event) {
    const itemAction = closest(event.target, '.item-action');
    if (!itemAction) return;

    const item = closest(itemAction, '.list-item');
    if (item.classList.contains('disabled')) return;

    if (item.dataset.type === 'group') {
      this.unselectGroup(item.dataset.id);
    } else {
      this.unselectMembers([item.dataset]);

      if (item.dataset.groups) {
        this.removeSelectedFromGroups(item.dataset.groups.split(','));
      } else {
        this.updateGroups();
      }
    }
  },

  fetchListContent(url, lastId = '') {
    return new Promise((resolve) => {
      $.ajax({
        url,
        method: 'GET',
        dataType: 'json',
        data: {
          keyword: this.searchInput.value,
          last_id: lastId,
        },
      }).done(result => resolve(result));
    });
  },

  fetchGroupMembers(url, groupId) {
    return new Promise((resolve) => {
      $.ajax({
        url,
        method: 'GET',
        dataType: 'json',
        data: { group_id: groupId },
      }).done(result => resolve(result));
    });
  },

  selectMembers(membersData) {
    const resultItems = document.createDocumentFragment();

    membersData.forEach((memberData) => {
      if (memberData.status === 'disabled') return;

      this.addItemToSelected(memberData.id);

      const memberItem = this.membersList.querySelector(`.member-item[data-id="${memberData.id}"]`);
      if (memberItem) memberItem.classList.add('selected');

      const resultItem = this.resultsList.querySelector(`.result-item[data-id="${memberData.id}"]`);
      if (!resultItem) resultItems.appendChild(this.renderResultItem(memberData));
    });

    this.resultsList.insertBefore(
      resultItems,
      this.resultsList.querySelector('.result-item:first-of-type'),
    );

    this.updateResultsCount();
  },

  unselectMembers(membersData) {
    membersData.forEach((memberData) => {
      if (memberData.status === 'disabled'
        || this.currentDisabledIds.indexOf(memberData.id) !== -1) return;

      this.removeIdFromSelected(memberData.id);

      const memberItem = this.membersList.querySelector(`.member-item[data-id="${memberData.id}"]`);
      if (memberItem) memberItem.classList.remove('selected');

      const resultItem = this.resultsList.querySelector(`.result-item[data-id="${memberData.id}"]`);
      if (resultItem) resultItem.remove();
    });

    this.updateResultsCount();
  },

  addItemToSelected(id) {
    const selectedIndex = this.currentSelectedIds.indexOf(id);
    if (selectedIndex === -1) this.currentSelectedIds.push(id);
  },

  removeIdFromSelected(id) {
    const selectedIndex = this.currentSelectedIds.indexOf(id);
    if (selectedIndex !== -1) this.currentSelectedIds.splice(selectedIndex, 1);
  },

  updateResultsCount() {
    this.resultsCount.innerText = this.currentSelectedIds.length - this.currentDisabledIds.length;
  },

  updateGroups(groupIds) {
    if (!this.groupsList || this.groupSelectable) return;

    if (groupIds) {
      ['all', ...groupIds].forEach(groupId => this.updateGroup(groupId));
    } else {
      [...this.groupsList.querySelectorAll('.group-item')]
        .forEach(item => this.updateGroup(item));
    }
  },

  updateGroup(groupIdOrItem) {
    let item = groupIdOrItem;
    if (typeof groupIdOrItem === 'string') {
      item = this.groupsList.querySelector(`.group-item[data-id="${groupIdOrItem}"]`);
    }
    if (!item) return;

    const groupMembers = item.dataset.members.split(',');
    if (groupMembers.some(id => this.currentSelectedIds.indexOf(id) === -1)) {
      item.classList.remove('selected');
    } else {
      item.classList.add('selected');
    }
  },

  removeSelectedFromGroups(groupIds) {
    if (!this.groupsList) return;

    groupIds.forEach((groupId) => {
      const item = this.groupsList.querySelector(`.group-item[data-id="${groupId}"]`);
      if (item) item.classList.remove('selected');
    });

    const allMemberItem = this.groupsList.querySelector('.group-item[data-id="all"]');
    if (allMemberItem) allMemberItem.classList.remove('selected');
  },

  transformListItems(itemsHTML) {
    const items = document.createDocumentFragment();
    const groupIds = [];

    $(itemsHTML).each((index, item) => {
      if (item.classList && item.classList.contains('list-item')) {
        const { id } = item.dataset;

        if (this.currentSelectedIds.indexOf(id) !== -1) {
          item.classList.add('selected');
        }

        if (this.currentDisabledIds.indexOf(id) !== -1) {
          item.classList.add('disabled');
        }

        if (item.classList.contains('group-item')) groupIds.push(id);
      }

      items.appendChild(item);
    });

    if (!this.groupSelectable && groupIds.length) this.updateGroups(groupIds);

    return items;
  },

  renderResultItem(data) {
    const resultItem = document.importNode(this.resultItemTemplate.content, true).firstElementChild;
    Object.assign(resultItem.dataset, data);

    resultItem.classList.add('selected');
    if (this.currentDisabledIds.indexOf(data.id) !== -1) {
      resultItem.classList.add('disabled');
    }
    resultItem.querySelector('.value').value = data.id;

    const itemContent = resultItem.querySelector('.item-content');
    const itemGraphic = itemContent.querySelector('.avatar, .icon');
    itemContent.replaceChild(this.renderResultGraphic(data), itemGraphic);
    itemContent.querySelector('.name').innerText = data.nickname || data.name;

    return resultItem;
  },

  renderResultGraphic(data) {
    let graphicNode;

    if (data.avatar) {
      graphicNode = document.createElement('img');
      graphicNode.classList.add('avatar');
      graphicNode.src = data.avatar;
    } else if (data.icon) {
      graphicNode = document.createElement('i');
      graphicNode.classList.add('twr', `twr-${data.icon}`, 'icon');
    }

    return graphicNode;
  },

  disconnected() {
    this.stopListening();
  },
});
